import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private forceProfileMenuOpenSub = new BehaviorSubject(false);
  forceProfileMenuOpen$ = this.forceProfileMenuOpenSub.asObservable();

  private triggerProfileMenuOpenSub = new Subject();
  triggerProfileMenuOpen$ = this.triggerProfileMenuOpenSub.asObservable();

  constructor() { }

  /**
   * Control auto closing behavior of profile menu
   * @param forceOpen If true, disable auto close of profile menu
   */
  setForceProfileMenuOpen(forceOpen: boolean) {
    this.forceProfileMenuOpenSub.next(forceOpen);
  }

  /**
   * Open or close profile menu
   */
  openProfileMenu(open: boolean) {
    this.triggerProfileMenuOpenSub.next(open);
  }
}
